export enum UserRole {
  STUDENT = 'student',
  TEACHER = 'teacher',
}

export enum OrganizerType {
  TEACHER = 'teacher',
  ACADEMY = 'academy',
  SCHOOL = 'school',
}
export interface TeacherEduProfile {
  role: OrganizerType
  v: number
}

export interface StudentEduProfile {
  role: UserRole.STUDENT
  v: number
}

export type Profile = {
  school?: StudentEduProfile | TeacherEduProfile
}

export interface Location {
  province: string
  county: string
}
